// extracted by mini-css-extract-plugin
module.exports = {"view":"DocumentView_view__2j7dc"};